import React from 'react'
import { storiesOf } from '@storybook/react'
import withReadme from 'storybook-readme/with-readme'
import StaticRenderer from '@emcm-ui/component-static-renderer'

// Digital-Commons Theming
import { ThemeProvider } from 'styled-components'
import { getBaseTheme } from '../..'

// Demo data imports
import demo404 from './demos/Sample404.json'
import demoData from './demos/SampleJSON.json'
import demoDataTree from './demos/SampleBnP_with-tree'
import demoRIC from './demos/SampleRIC-frozen.json' // './demos/SampleRIC1.json'
import demoServersideCheckbox from './demos/SampleBnP1'
import download from './demos/SampleDownload'

import i18n from './demos/i18n'

// Component to surface in storybook
import DataTable from '.'
import readme from './readme.md'
import './demos/integration'
import './demos/analytics_integration'

// Story Setup
const stories = storiesOf('Digital-Commons/Datatable', module)

stories.addDecorator(withReadme(readme))

// Theming setup
const mode = 'refinitiv'
const baseTheme = getBaseTheme({ mode })
const builtTheme = {
  mode,
  ...baseTheme
}

const propagation = {
  "enabled": true,
  "callback": "analytics.analyticsCapture"
}

demoData.component_config.analyticsPropagationHandler = propagation

// Stories
stories
  .add('Default', () => (
    <ThemeProvider theme={builtTheme}>
      <DataTable {...demoData} i18n={i18n.content} />
    </ThemeProvider>
  ))
  .add('Presentable', () => (
    <div style={{width:'100%', height:'2400px', background:'white'}}>
      <div style={{width:'75%', margin: '0 auto'}}>
        <ThemeProvider theme={builtTheme}>
          <DataTable {...demoData} i18n={i18n.content} />
        </ThemeProvider>
      </div>
    </div>
  ))
  .add('404 Status', () => (
    <ThemeProvider theme={builtTheme}>
      <DataTable {...demo404} i18n={i18n.content} />
    </ThemeProvider>
  ))
  .add('With MultiSelectTree', () => (
    <ThemeProvider theme={builtTheme}>
      <DataTable {...demoDataTree} i18n={i18n.content} />
    </ThemeProvider>
  ))
  .add('RIC', () => (
    <ThemeProvider theme={builtTheme}>
      <DataTable {...demoRIC} i18n={i18n.content} />
    </ThemeProvider>
  ))
  .add('Billing & pymnts', () => (
    <ThemeProvider theme={builtTheme}>
      <DataTable {...demoServersideCheckbox} i18n={i18n.content} />
    </ThemeProvider>
  ))
  .add('Download (client) Page', () => (
    <ThemeProvider theme={builtTheme}>
      <DataTable {...download} i18n={i18n.content} />
    </ThemeProvider>
  )).add("Rehydrated", () => {
    return (
      <StaticRenderer>
        <ThemeProvider theme={builtTheme}>
          <DataTable {...demoData} i18n={i18n.content} />
        </ThemeProvider>
      </StaticRenderer>
    )
  })
